module.exports = __webpack_public_path__ + "static/media/loader-inf.b3d0088b.gif";